import { render } from "./BackTop.vue?vue&type=template&id=eab4c8ca&scoped=true&ts=true"
import script from "./BackTop.vue?vue&type=script&lang=ts"
export * from "./BackTop.vue?vue&type=script&lang=ts"

import "./BackTop.vue?vue&type=style&index=0&id=eab4c8ca&lang=scss&scoped=true"

import exportComponent from "D:\\otimes-en\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eab4c8ca"]])

export default __exports__